import { Redirect, Route, useLocation } from "react-router-dom";

import { isAuthenticated } from "src/helpers/auth";
import { isAllowedRoute } from "src/helpers/role";
import privateRoutes from "./private-routes";
import publicRoutes from "./public-routes";

function RouteWrapper({ isPrivate = false, isGlobal = false, ...routeProps }) {
  const signed = isAuthenticated();
  const hasAction = new URLSearchParams(useLocation().search).get("actions");
  const homeRoute =
    hasAction === "open-chat" ? `${privateRoutes.home.path}?actions=open-chat` : privateRoutes.home.path;

  if (isPrivate && !signed) {
    return <Redirect to={publicRoutes.login.path} />;
  }
  if (!isPrivate && signed && !isGlobal) {
    return <Redirect to={homeRoute} />;
  }
  if (isPrivate && !isAllowedRoute(routeProps.path)) {
    return <Redirect to={publicRoutes.notFound.path} />;
  }
  return <Route {...routeProps} />;
}

export default RouteWrapper;
